import React from "react";
import { Book } from 'components/Book';
import { BlockLayout } from '../BlockLayout';

export const BookBlock = ({ title, pages }) => (
    <BlockLayout stacked title={title}>
        <Book pages={pages} />
    </BlockLayout>
);
